
import i18n from "../../i18n";
import { apiCallBegan } from "../api";
import { AppDispatch, AppState } from "../configureStore";
import { authHeader, isAuthenticated } from "./auth";
import { getWorkerId } from "./auth";

export const updateUserLanguage = (lng: string) => async (dispatch: AppDispatch, getState: () => AppState) => {
    const workerId = getWorkerId(getState());

    if (!workerId || !lng) {
        return;
    }

    return isAuthenticated()
        ? await dispatch(
            apiCallBegan({
                url: "/api/workers/language/" + workerId,
                method: "POST",
                headers: {
                    ...authHeader(),
                    "Accept-Language": lng ? lng : i18n.language
                }
            })
        )
        : null;
};